/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_a10f94ae{background:blue}\n"}]);
export const dummy = "dummy_a10f94ae";